import { Grid, LinearProgress, Typography, useTheme } from "@mui/material";
import { Small } from "./Typography";

const ProgressBar = ({
  text = "",
  value = 75,
  spacing = 2,
  color = "primary",
  coloredText = false,
}) => {
  const theme = useTheme();
  const secondary = theme.palette.text.secondary;

  return (
    <Grid container spacing={spacing} alignItems="center">
      <Grid item xs={text ? 8 : 12}>
        <LinearProgress
          color={color}
          value={value}
          variant="determinate"
          sx={{ borderRadius: 2, background: "rgba(0, 0, 0, 0.1)" }}
        />
      </Grid>

      {text !== "" && (
        <Grid item xs={text ? 4 : false}>
          <Typography color={color}>
            <Small sx={coloredText ? { color: secondary } : {}}>{text}</Small>
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

export default ProgressBar;
